<template>
    <div class="socialevents">
        <div class="destination-container">
            <div class="destination-writeups mt-4">
            <!-- Check if banner exists -->
            <template v-if="aboutList.banner">
                <!-- If it's an image -->
                <img
                v-if="isImage(aboutList.banner)"
                :src="base_url + aboutList.banner"
                alt="Banner Image"
                style="max-width: 100%; border-radius: 10px;"
                />

                <!-- If it's a video -->
                <video
                v-else-if="isVideo(aboutList.banner)"
                :src="base_url + aboutList.banner"
                controls
                style="max-width: 100%; border-radius: 10px;"
                ></video>

                <!-- If file type is not supported -->
                <p v-else style="color: red;">Unsupported media format</p>
            </template>

            <!-- No banner -->
            <p v-else style="color: gray;">No media available</p>
            </div>

            <div class="card-container">
                <h2>Our Story</h2>
                <p v-html="aboutList.our_story">
                </p>
               
                <button @click="joinNow()">
                    <p>Join Us</p>
                    <MoveRight />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { MoveRight } from "lucide-vue-next";
import { ref, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";
const aboutList = ref([]);

let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";

onMounted( async () => {
  await listRecords();
});

onBeforeUnmount( async () => {
  
});

// Action methods
const joinNow = async() => {
    router.push(`/register`);
}
const listRecords = async () => {
  try {
    const response = await axios.get('/about_list.php', { });
    if (response.data.status) aboutList.value = response.data.data[0];
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const isImage = (file) => {
  return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file);
};

const isVideo = (file) => {
  return /\.(mp4|mov|webm|avi|mkv)$/i.test(file);
};

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 90%;
    margin: auto;
    margin-top: 5rem;
}

.destination-container {
    display: flex;
    justify-content: space-between;
    align-items: start;

    .destination-writeups {
        width: 45%;

        img {
            width: 100%;
            height:  350px;
            border-radius: 20px;
        }
        video{
            width: 100%;
            height: 350px;
            border-radius: 20px;
        }
    }

    .card-container {
        width: 50%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: start;

        h2 {
            font-size: 48px;
            font-weight: 700;
            margin: 10px 0;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }

        p {
            font-size: 16px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
            color: #555555;
            margin-top: 20px;
        }

        button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            background-color: #ED4E24;
            border: 2px solid #ED4E24;
            border-radius: 60px;
            width: 147px;
            height: 52px;
            color: #fff;

            p {
                padding: 0%;
                margin: 0%;
                color: #fff;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
        }
    }
}

@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .destination-container {
        display: flex;
        flex-direction: column;
        align-items: start;

        .destination-writeups {
            width: 100%;

            img {
                width: 100%;
                height: 100%;
                border-radius: 20px;
            }
        }

        .card-container {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            //gap: 20px;
            width: 100%;

            h2 {
            text-align: center;
            }

            p {
                text-align: center;
                padding: 15px;
            }
            button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            background-color: #ED4E24;
            border: 2px solid #ED4E24;
            border-radius: 60px;
            width: 147px;
            height: 52px;
            color: #fff;
            margin-left: 20px;

            p {
                padding: 0%;
                margin: 0%;
                color: #fff;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
          }
        }
    }
}
</style>
